<template>
  <div class="tab-view-content">
    <van-tabs
      v-model="name"
      color="#035F92"
      title-active-color="#fff"
      title-inactive-color="#999999"
      :type="menuType"
      :ellipsis="false"
    >
      <van-tab
        v-for="(item, index) in menu"
        :key="index"
        :title="item.meta.title"
        :name="item.meta.id"
        :to="item.path && item.path"
        :title-class="flexInherit ? 'flexInherit' : ''"
      />
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: "MenuCom",
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    flexInherit: {
      type: Boolean,
      fafault: false,
    },
    menuType: {
      type: String,
      default: "card",
    },
  },
  data() {
    return {
      name: "",
    };
  },
  methods: {
    changeRoute(val, oldVal) {
      this.name = val.mate.id;
    },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.name = val.meta.id;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
